export default __webpack_public_path__ + "static/media/91@2x-8.5c6dc7ab.png";